














import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import SmsMessages from './tables/smsMessages.vue';

@Component({
	components: { SmsMessages },
})
export default class AlertCountProgress extends Vue {
	@Prop({ type: Array, required: true })
	public readonly alerts!: any[];
	@Prop({ type: Number, required: true })
	public readonly smsCount!: number;
	@Prop({ type: Number, required: true })
	public readonly maxSmsCount!: number;
	public progressVariant: 'default' | 'warning' | 'danger' = 'default';

	@Watch('smsCount')
	@Watch('maxSmsCount')
	public watch(): void {
		const percentage = this.smsCount / this.maxSmsCount;
		if (percentage >= 0.95) this.progressVariant = 'danger';
		else if (percentage >= 0.85) this.progressVariant = 'warning';
		else this.progressVariant = 'default';
	}
}
